module.exports = __webpack_public_path__ + "img/slide2-768.5efd2131.png";